import {
  CANCEL_OTP,
  CANCEL_OTP_FAILURE,
  CANCEL_OTP_SUCCESS,
  CHANGE_INPUT,
  CHANGE_SCHEDULED_DATE,
  CHANGE_SCHEDULED_DATE_ON_DECK,
  CHANGE_STEP,
  CREATE_OTP,
  CREATE_OTP_FAILURE,
  CREATE_OTP_SUCCESS,
  CREATE_OTP_VALIDATION_FAILURE,
  FETCH_PAYMENT_HOME,
  FETCH_PAYMENT_HOME_FAILURE,
  FETCH_PAYMENT_HOME_SUCCESS,
  NACHA_SAVE_TOKEN,
  RESET_BANNER_ERROR,
  RESET_CANCEL_CONFIRMATION,
  RESET_CONFIRMATION,
  RESET_ONE_TIME_PAYMENT_STATE,
  RESET_STEP,
  SET_BANNER_ERROR,
  SET_IS_AMOUNT_DRAWER_OPEN,
  SET_IS_MODAL_OPEN,
  UPDATE_AMOUNT,
  UPDATE_PAYMENT_HOME_INIT,
} from './constants';

export function cancelOtp({ navigationType = 'navigate' } = {}) {
  return {
    payload: { navigationType },
    type: CANCEL_OTP,
  };
}

export function cancelOtpFailure() {
  return { type: CANCEL_OTP_FAILURE };
}

export function cancelOtpSuccess(cancelConfirmation) {
  return {
    payload: { cancelConfirmation },
    type: CANCEL_OTP_SUCCESS,
  };
}

export function changeInput({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT,
  };
}

export function changeScheduledDate(value, shouldClearOnDeck = false) {
  return {
    payload: { shouldClearOnDeck, value },
    type: CHANGE_SCHEDULED_DATE,
  };
}

export function changeScheduledDateOnDeck(value) {
  return {
    payload: { value },
    type: CHANGE_SCHEDULED_DATE_ON_DECK,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function createOtp(payload) {
  return {
    payload,
    type: CREATE_OTP,
  };
}

export function createOtpFailure() {
  return { type: CREATE_OTP_FAILURE };
}

export function createOtpSuccess(payload) {
  return {
    payload,
    type: CREATE_OTP_SUCCESS,
  };
}

export function createOtpValidationFailure(payload) {
  return {
    payload,
    type: CREATE_OTP_VALIDATION_FAILURE,
  };
}

export function nachaSaveToken(token) {
  return {
    payload: { token },
    type: NACHA_SAVE_TOKEN,
  };
}

export function fetchPaymentHome(loanNumber) {
  return {
    payload: { loanNumber },
    type: FETCH_PAYMENT_HOME,
  };
}

export function fetchPaymentHomeFailure() {
  return { type: FETCH_PAYMENT_HOME_FAILURE };
}

export function fetchPaymentHomeSuccess(payload) {
  return {
    payload,
    type: FETCH_PAYMENT_HOME_SUCCESS,
  };
}

export function resetBannerError() {
  return { type: RESET_BANNER_ERROR };
}

export function resetCancelConfirmation() {
  return { type: RESET_CANCEL_CONFIRMATION };
}

export function resetConfirmation() {
  return { type: RESET_CONFIRMATION };
}

export function resetOneTimePaymentState() {
  return { type: RESET_ONE_TIME_PAYMENT_STATE };
}

export function resetStep() {
  return { type: RESET_STEP };
}

export function setBannerError(value) {
  return {
    payload: { value },
    type: SET_BANNER_ERROR,
  };
}

export function setIsAmountDrawerOpen(value) {
  return {
    payload: { value },
    type: SET_IS_AMOUNT_DRAWER_OPEN,
  };
}

export function setIsModalOpen({ key, value }) {
  return {
    payload: { key, value },
    type: SET_IS_MODAL_OPEN,
  };
}

export function updateAmount({ amount, payType }) {
  return {
    payload: { amount, payType },
    type: UPDATE_AMOUNT,
  };
}

export function updatePaymentHomeInit(state) {
  return {
    payload: { state },
    type: UPDATE_PAYMENT_HOME_INIT,
  };
}
